import { createV3Queries } from "@query/utils/createV3Queries";
import { payableRowsApi } from "@api";

/**
 * v3 registry for the payer-seat payable search rows
 * (`GET /v3/search/payable-rows`) — the denormalized, materialized row that
 * backs the payables dashboard list/table. This is the v3 twin of the v1
 * payments-service `/v2/payments/payables` list: cursor pagination + the legacy
 * filter surface (status, payer approval status, payee id, due date, event
 * timestamps, batch ids), returning a `PayableRow` that carries the columns the
 * table renders (including the denormalized payee `profile`/`email`, so no
 * separate payee join is needed) plus a `summary` (`{ count, amountTotal }`)
 * that replaces the separate v1 summary request.
 */
export const queriesPayableRows = createV3Queries(
  "payableRowsApi",
  payableRowsApi
);
